import React from 'react';
import { useIntl } from 'umi';
import { Popover } from 'tea-component';
import { IS_GLOBAL, IS_WOA,  } from '@/pages/home/_config/config';
import { buriedBtnPoint } from '@/pages/home/utils/buriedPoint';
import agentWorkbuddy from '@/pages/aigc/assets/svg/workbuddy.svg';
import agentPlatformWecom from '@/pages/aigc/assets/svg/agent-wecom.svg';
import agentPlatformKnot from '@/pages/aigc/assets/svg/agent-knot.svg';
import './index.scss';
/** 企业微信跳转协议链接 */
const WECOM_LINK = 'wxwork://message/?uin=33776997310281596';

/** Knot Skills 市场搜索页链接 */
const KNOT_MARKET_LINK = 'https://knot.woa.com/skills/market?keyword=databrain';

/**
 * 平台选择下拉面板
 * 展示 WorkBuddy 和 企业微信两个平台入口及其操作指引
 */
const PlatformDropdown: React.FC = () => {
  const { formatMessage } = useIntl();

  /** 跳转企业微信聊天（打点 + 协议跳转） */
  const handleOpenWecom = () => {
    buriedBtnPoint({
      pageId: '700501',
      buttonId: '70090114',
      extInfo: JSON.stringify({ action: 'wecom_jump' }),
      typeId: 'aigc',
    });
    window.open(WECOM_LINK, '_self');
  };

  /** 跳转 Knot Skills 市场（打点 + 新窗口打开） */
  const handleOpenKnot = () => {
    buriedBtnPoint({
      pageId: '700501',
      buttonId: '70090115',
      extInfo: JSON.stringify({ action: 'knot_jump' }),
      typeId: 'aigc',
    });
  };

  return (
    <div className="dba-more-platform-dropdown">
      {/* WorkBuddy */}
      <div className="dba-more-platform-row">
        <span className="dba-more-platform-badge">1</span>
        <div className="dba-more-platform-col">
          <div className="dba-more-platform-line">
            {formatMessage({ id: 'dba_platform_pre_in' })}
            <img src={agentWorkbuddy} alt="workbuddy" className="dba-more-platform-icon" />
            {formatMessage({ id: 'dba_platform_workbuddy_desc1' })}
          </div>
          <div className="dba-more-platform-line">
            {formatMessage({ id: 'dba_platform_workbuddy_desc2' })}
          </div>
        </div>
      </div>

      {/* 企业微信 */}
      <div className="dba-more-platform-row dba-more-platform-row-wecom">
        <span className="dba-more-platform-badge">2</span>
        <div className="dba-more-platform-line">
          {formatMessage({ id: 'dba_platform_pre_in' })}
          <img src={agentPlatformWecom} alt="wecom" className="dba-more-platform-icon" />
          {formatMessage({ id: 'dba_platform_wecom_desc' })}
          {formatMessage({ id: 'dba_platform_open' })}
          <img src={agentPlatformWecom} alt="wecom" className="dba-more-platform-icon" />
          <span className="dba-more-platform-link" onClick={handleOpenWecom}>
            {formatMessage({ id: 'dba_platform_wecom_name' })}
          </span>
          {formatMessage({ id: 'dba_platform_chat' })}
        </div>
      </div>

      {/* Knot（仅 WOA 环境展示） */}
      {IS_WOA && (
        <div className="dba-more-platform-row dba-more-platform-row-knot">
          <span className="dba-more-platform-badge">3</span>
          <div className="dba-more-platform-line">
            {formatMessage({ id: 'dba_platform_pre_in' })}
            <img src={agentPlatformKnot} alt="knot" className="dba-more-platform-icon" />
            {formatMessage({ id: 'dba_platform_knot_desc1' })}
            <a
              className="dba-more-platform-link"
              href={KNOT_MARKET_LINK}
              target="_blank"
              rel="noreferrer"
              onClick={handleOpenKnot}
            >
              DataBrain
            </a>
            {formatMessage({ id: 'dba_platform_knot_desc2' })}
          </div>
        </div>
      )}
    </div>
  );
};

/**
 * 更多平台使用按钮
 * 位于 Agent Home 页面右上角，hover 时展示平台下拉面板
 * 支持通过 WorkBuddy / 企业微信跳转使用 DataBrain Agent
 */
const MorePlatformBtn: React.FC = () => {
  const { formatMessage } = useIntl();

  // global 环境不展示此功能
  if (IS_GLOBAL) return null;

  return (
    <div className="dba-more-platform-btn">
      <Popover
        trigger="hover"
        placement="bottom-end"
        placementOffset={[0, 8]}
        overlayClassName="dba-more-platform-popover"
        overlay={<PlatformDropdown />}
      >
        <div className="dba-more-platform-btn-trigger">
          <div className="dba-more-platform-btn-inner">
            <span className="dba-more-platform-btn-text">
              {formatMessage({ id: 'dba_platform_more_btn' })}
            </span>
            <span className="dba-more-platform-btn-icons">
              <img src={agentWorkbuddy} alt="workbuddy" className="dba-more-platform-btn-icon" />
              <img src={agentPlatformWecom} alt="platform" className="dba-more-platform-btn-icon" />
              {IS_WOA && (
                <img src={agentPlatformKnot} alt="knot" className="dba-more-platform-btn-icon" />
              )}
            </span>
          </div>
        </div>
      </Popover>
    </div>
  );
};

export default MorePlatformBtn;
